"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retryFn = void 0;
/**
 * Maximum number of retry attempts for React Query
 */
var RETRY_COUNT = 3;
/**
 * List of HTTP status codes that should trigger a retry
 * - 408: Request Timeout
 * - 429: Too Many Requests
 * - 500: Internal Server Error
 * - 502: Bad Gateway
 * - 503: Service Unavailable
 * - 504: Gateway Timeout
 */
var RETRY_STATUS_CODES = [408, 429, 500, 502, 503, 504];
/**
 * Retry function for React Query's retry option
 * Retries only for specific HTTP status codes
 *
 * @param failureCount - Number of failures so far (starts from 0)
 * @param error - Error object (must include error.status)
 * @returns Whether to retry (true: retry, false: do not retry)
 */
var retryFn = function (failureCount, error) {
    var status = error.status;
    return RETRY_STATUS_CODES.includes(status) && failureCount < RETRY_COUNT - 1;
};
exports.retryFn = retryFn;
